<template>
  <div class="container" :style="{ color: color, background: background }">
    <wrap-container class="textContainer">
      <footer class="footerInfo">
        <div>
          <p class="titulo p24 medium bold">Información importante:</p>
          <ul>
            <li>
              <p>
                La casa tiene que ser de uso permanente y debe cumplir con las
                normas mínimas de seguridad.
                <span class="modal-link" @click="ModalRequisitos"
                  >Mostrar requisitos</span
                >
              </p>
            </li>
            <li>
              <p>
                La vigencia del seguro es anual y se renueva automáticamente.
              </p>
            </li>
            <li>
              <p>Pódes darle de baja cuando quieras.</p>
            </li>
            <li>
              <p>Las sumas aseguradas se ajustarán trimestralmente.</p>
            </li>
            <li>
              <p>
                Bases de la promoción.
                <span class="modal-link" @click="ModalCondiciones"
                  >Mostrar condiciones</span
                >
              </p>
            </li>
          </ul>
        </div>
      </footer>
    </wrap-container>
    <modal-component
      :label="config.pasos.paso2.titulo_modalRequisitos"
      :show="showModalRequisitos"
      :buttonLabel="infoRequisito.boton"
      @close="closeRequisitos"
      @aceptar="closeRequisitos"
      :bodyScroll="true"
      :large="true"
    >
      <p class="modal-text">
        a. La casa debe tener techos sólidos y paredes exteriores de material
        (ambos incombustibles), construidos de mampostería, ladrillo y/u
        hormigón.<br /><br />
        b. La casa debe ser de uso permanente de la persona que la asegura y no
        deben realizarse actividades comerciales.<br /><br />
        c. No debe lindar con terrenos baldíos, obras en construcción o
        edificios abandonados. Debe tener una protección perimetral de 1.80
        metros de altura que impida el acceso del exterior (no aplica en
        countrys o barrios cerrados con vigilancia).<br /><br />
        d. Las puertas de acceso deben contar con cerraduras doble paleta,
        trabex o ser bidimensionales.<br /><br />
        e. La casa debe tener rejas de protección de hierro en cualquier panel
        de vidrio, policarbonato o similar (mientras esté ubicada en la planta
        baja o primer piso) o un sistema de alarma monitoreada que debe estar
        activado cada vez que la persona que aseguró la vivienda se ausente.<br /><br />
        Este requisito aplica para Gran Buenos Aires, Ciudad Autónoma de Buenos
        Aires y en las ciudades de La Plata, Rosario, Córdoba, Mendoza y Mar del
        Plata. En el resto del país se acepta como protección, los postigones o
        paneles de doble vidrio.<br /><br />
        Si ocurre un siniestro a causa de la falta de alguna de estas medidas de
        seguridad, se podrán aplicar quitas al momento de liquidar el seguro. En
        caso de que ocurra un incendio a causa de los puntos a o b, la compañía
        aseguradora puede prescindir de tener que abonar el siniestro.<br /><br />
        La superficie cubierta a asegurar debe estar comprendida en un rango de
        33 a 647 metros cuadrados, inclusive.
      </p>
    </modal-component>
    <modal-component
      :label="config.pasos.paso2.titulo_modalCondiciones"
      :show="showModalCondiciones"
      :buttonLabel="infoRequisito.boton"
      @close="closeCondiciones"
      @aceptar="closeCondiciones"
      :bodyScroll="true"
      :large="true"
    >
      <div class="modal-text">
        <strong>¿Hasta cuándo podés beneficiarte de esta promoción?</strong>
        <p>
          Esta promoción es válida para la República Argentina, desde el 1 de
          Julio hasta el 30 de Septiembre de 2026, inclusive.
        </p>
        <br />
        <strong>¿En qué consiste la promoción?</strong>
        <p>
          Todo Cliente de Banco BBVA Argentina S.A. (BBVA) que contrate un NUEVO
          Seguro de Hogar Premier de BBVA Seguros Argentina S.A. (BBVA Seguros),
          a través de Banca online en
          <a href="https://www.bbva.com.ar" target="_blank">www.bbva.com.ar</a>
          ó por la app de BBVA, podrá beneficiarse con un 15%* de descuento
          sobre la prima, en las 4 (cuatro) primeras cuotas. <br />*Este
          porcentaje (%) se aplica sobre la prima (cuota/premio menos la tasa
          SSN).
        </p>
        <br />
        <strong
          >¿Qué requisitos debés cumplir para poder acceder a la
          promoción?</strong
        ><br />
        <ul>
          <li>• Ser Cliente de BBVA.</li>
          <li>
            • Pagar exclusivamente mediante débito automático sobre una Tarjeta
            de Crédito VISA o MasterCard de BBVA.
          </li>
        </ul>
        <br />
        <strong>¿Cómo se aplican los descuentos?</strong><br />
        <ul>
          <li>
            En oportunidad de la cotización, se muestra el plan y costo que se
            podrá otorgar.
          </li>
          <li>Este costo NO Incluye la bonificación sobre la prima.</li>
          <li>
            <p>
              Una vez que decidas tomar la cobertura y que se procesa el alta
              (emisión), en el frente de Póliza se indicará el 100% de la
              prima/premio.
            </p>
          </li>
          <li>
            Recién en el primer cobro podrás ver en tu Resumen de Tarjeta el
            monto con el descuento, incluido.
          </li>
        </ul>
        <br />
        <strong>¿Qué otra información importante debés tener en cuenta?</strong
        ><br />
        <ul>
          <li>
            Esta promoción no es combinable, canjeable por dinero ni tampoco
            acumulable con otras promociones.
          </li>
          <li>
            Organizador: BBVA Seguros Argentina S.A., Av. Córdoba 111, Piso 22
            de la Ciudad Autónoma de Buenos Aires.
          </li>
          <li>
            <p>
              Exclusiones: quedan excluidos del beneficio: (i) aquellos Clientes
              que hayan contratado un Seguro de BBVA SEGUROS de una rama
              determinada y lo hubieran dado de baja dentro de la vigencia de LA
              PROMO a modo de reemplazo de una póliza anterior de rama idéntica
              a la anteriormente contratada; (ii) aquellos Clientes que hayan
              realizado un upgrade de un seguro contratado con anterioridad.
            </p>
          </li>
          <li>
            <p>
              Para más información y condiciones o limitaciones aplicables,
              consulte en
              <a
                href="https://www.bbva.com.ar/personas/productos/seguros"
                target="_blank"
                >www.bbva.com.ar/personas/productos/seguros</a
              >
            </p>
          </li>
        </ul>
        <br />
        <p>
          Compañía Aseguradora: BBVA Seguros Argentina S.A., Av. Córdoba 111,
          Piso 22, C1054AAA C.A.B.A., CUIT 30-50006423-0 .N° de inscripción en
          SSN: 0396. Agente Institorio Banco BBVA Argentina S.A., Av. Córdoba
          111, Piso 31, C1054AAA, CABA. CUIT 30-50000319-3.- N° de inscripción
          en SSN: 0135. Superintendencia de Seguros de la Nación 4338-4000 o
          0-800-666-8400,
          <a href="https://www.ssn.gob.ar" target="_blank">www.ssn.gob.ar</a>.
          Los accionistas de Banco BBVA Argentina S.A. limitan su
          responsabilidad a la integración de las acciones suscriptas a la ley
          19.550 y ley 25.738.
        </p>
        <br />
      </div>
    </modal-component>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import ModalComponent from "@/components/core/ModalComponent";
import * as MUTATIONS from "@/config/constants/mutation-types";

export default {
  name: "AppFooterSeguros",
  components: { WrapContainer, ModalComponent },
  props: {
    text: String,
    color: {
      type: String,
      default: "#121212"
    },
    background: {
      type: String,
      default: "#F4F4F4"
    }
  },
  data() {
    return {
      showModalRequisitos: false,
      showModalCondiciones: false,
      infoRequisito: {
        boton: "Entendido"
      }
    };
  },
  methods: {
    ModalRequisitos() {
      this.showModalRequisitos = true;
      this.$store.commit(MUTATIONS.ADOBE_MODAL, {
        name: "requisitos"
      });
    },
    ModalCondiciones() {
      this.showModalCondiciones = true;
      this.$store.commit(MUTATIONS.ADOBE_MODAL, {
        name: "condiciones"
      });
    },
    closeRequisitos() {
      this.showModalRequisitos = false;
    },
    closeCondiciones() {
      this.showModalCondiciones = false;
    }
  }
};
</script>

<style scoped>
.container {
  background: #043263;
  color: #e4e4e4;
  font-size: 12px;
  line-height: 1.5em;
  padding-top: 100px;
  padding-bottom: 100px;
  padding-left: auto;
  padding-right: auto;
  margin-left: -17px;
  margin-right: -17px;
  text-align: justify;
  margin-bottom: 0px;
}
.textContainer {
  min-width: 1200px;
  margin: 10px;
}
.footerInfo {
  max-width: 1200px;
  margin: auto;
  width: 100%;
}
ul {
  margin-left: -45px;
}
ul li {
  list-style: none;
  padding-left: 2rem;
  background-image: url("../../assets/img/1x/bullet.png");
  background-position-y: 0;
  background-size: 1.6rem 1.6rem;
  background-repeat: no-repeat;
  margin-bottom: 15px;
  font-size: 15px;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
}
.modal-link {
  color: #1973b8;
  font-family: "BentonSansBBVA-Bold", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 24px;
  cursor: pointer;
}
.modal-text {
  font-size: 15px;
}

@media screen and (max-width: 772px) {
  .container {
    padding: 25px 5px;
  }

  .textContainer {
    max-width: 100%;
    width: 90%;
    min-width: 90%;
  }

  .titulo {
    font-size: 22px;
  }
}
</style>
